export enum DeviceResultTypeEnum {
    warning = 0,
    error = 1,
    notPresent = 2,
    success = 3,
    placeholder = 4,
    invalid = 5
}
